export default {"src":"/_next/static/media/oneMoneyLogo.242b82ec.svg","height":21,"width":90,"blurWidth":0,"blurHeight":0};